let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dhYCG")).then(() => parcelRequire('3H5Fj'));